const getServiceForTeam = {
  variable: [
    '$duration: Duration!',
    '$serviceReq:ServiceReq!',
    '$permissions: [String]',
  ],
  query: `
    services: getServiceForTeam(duration: $duration, serviceReq:$serviceReq, permissions: $permissions) {
      key: id
      label: name
      permissions
    }
  `,
};

const readMetricsValues = {
  variable: ['$condition: MetricsCondition!, $duration: Duration!'],
  query: `
      readMetricsValues: readMetricsValues(condition: $condition, duration: $duration) {
        label
        values {
          values {value}
        }
      }`
};

const readMetricsValuesCompare = {
  variable: ['$condition: MetricsCondition!, $durationCurrent: Duration!, $durationCompare: Duration!'],
  query: `
   readMetricsValues(condition: $condition, duration: $durationCurrent) {
      label
      values {
        values {value}
      }
      avg
      total
      perMin
    }
    compared: readMetricsValues(condition: $condition, duration: $durationCompare)  {
      label
      values {
        values { value }
      }
      avg
      total
      perMin
    }`
};

const k8sDashboard = {
  variable: [
    '$request: K8sMetricConditition!, $duration: Duration!, $valueColumn: String',
  ],
  query: `
          k8sDashboard(request: $request, duration: $duration, valueColumn: $valueColumn) {
            metricsValue{
                name,
                value
            }
        }
        `,
};

const k8sTable = {
  variable: [
    '$tableOverviewRequest: TableOverviewRequest!',
    '$duration: Duration!',
    '$pagination: Pagination',
    '$sortCriteria: [SortCriteria!]',
  ],
  query: `
        k8sGetTableOverview(tableOverviewRequest: $tableOverviewRequest, duration: $duration, pagination: $pagination, sortCriteria: $sortCriteria) {
            metricsValue{
                name,
                value
            }
            totalEntities
        }
        `,
};

const k8sNamespaceTable = {
  variable: [
    '$tableOverviewRequest: TableOverviewRequest!',
    '$duration: Duration!',
    '$pagination: Pagination',
    '$instanceList: [String]',
    '$sortCriteria: [SortCriteria!]',
  ],
  query: `
          k8sNamespaceTableMetrics(tableOverviewRequest: $tableOverviewRequest, duration: $duration, pagination: $pagination, instanceList: $instanceList, sortCriteria: $sortCriteria) {
            metricsValue{
                name,
                value
            }
            totalEntities
        }
        `,
};

const k8sServiceInstanceCount = {
  variable: [
    '$serviceId: String!',
    '$duration: Duration!',
    '$instanceTypes: [String]!',
  ],
  query: `
          k8sServiceInstanceCount(serviceId: $serviceId, duration: $duration, instanceTypes: $instanceTypes) {
            metricsValue{
                name,
                value
            }
        }
        `,
};

const readAllMetricsFilteredAtServiceScopeTemplate = {
  variable: [
    '$condition: MetricsCondition!',
    '$duration: Duration!',
    '$valueColumn: String',
    '$properties: [KeyValuePair!]!',
    '$entityIds: [String!]!',
  ],
  query: `readAllMetricsFilteredAtServiceScope: readAllMetricsFilteredAtServiceScope(
    condition: $condition,
    duration: $duration, valueColumn: $valueColumn, properties: $properties, entityIds: $entityIds) {
    label
    values {
      values {id value}
    }
    avg 
    max
    total
    perMin
}`
}

const readAllMetricsFilteredAtServiceScopeTemplateCompare = {
  variable: [
    '$condition: MetricsCondition!',
    '$durationCurrent: Duration!',
    '$durationCompare: Duration!',
    '$valueColumn: String',
    '$properties: [KeyValuePair!]!',
    '$entityIds: [String!]!',
  ],
  query: `
     readAllMetricsFilteredAtServiceScope(condition: $condition, duration: $durationCurrent, valueColumn: $valueColumn, properties: $properties, entityIds: $entityIds) {
      label
      values {
        values {id value}
      }
      avg 
      max
      total
      perMin
      }
      compared: readAllMetricsFilteredAtServiceScope(condition: $condition, duration: $durationCompare, valueColumn: $valueColumn, properties: $properties, entityIds: $entityIds) {
      label
      values {
        values {id value}
      }
      avg 
      max
      total
      perMin
      }`
};

const getK8InstanceByMetaProperties = {
  variable: [
    '$duration: Duration',
    '$serviceId: ID!',
    '$properties: [KeyValuePair!]!',
  ],
  query: `instanceId: getServiceInstancesByMetaProperties(duration: $duration,serviceId: $serviceId, properties: $properties) {     
    key: id
    label: name
    attributes {
      name
      value
    }
}`,
};

const getK8CardsProperties = {
  variable: [
    '$request: K8sMetricConditition!',
    '$duration: Duration!',
    '$valueColumn: String',
  ],
  query: `k8sLatestMetric(request: $request,duration: $duration,valueColumn: $valueColumn) {     
    metricsValue{
      name,
      value
  }
}`,
};

const getK8Attributes = {
  variable: ['$entityId: String!'],
  query: `
      k8sGetMetaProperties: k8sGetMetaProperties(entityId: $entityId) {
        metaProperty1,
        metaProperty2,
        metaProperty3,
        metaProperty4,
        metaProperty5,
        metaProperty6,
        metaProperty7,
      }
      `,
};

const getAllK8Instances = {
  variable: [
    '$serviceId: ID!',
    '$properties: [KeyValuePair!]!',
    '$keyword: String',
    '$limit: Int',
  ],
  query: `instanceId: getServiceInstancesByMetaProperties(serviceId: $serviceId, properties: $properties, keyword: $keyword, limit: $limit) {     
    key: id
    label: name
}`,
};

export const getServiceForTeamWithTotalCount = {
  variable: ['$keyword: String', '$duration: Duration!', '$serviceReq: ServiceReq!', '$pagination: Pagination', '$permissions: [String]'],
  query: `
    services: getServiceForTeamWithTotalCount(keyword: $keyword, duration: $duration, serviceReq: $serviceReq, pagination: $pagination, permissions: $permissions) {
      services {
        key: id
        label: name
        permissions
      }
      total
    }
  `
}

export default {
  getServiceForTeamWithTotalCount,
  getServiceForTeam,
  readMetricsValues,
  k8sDashboard,
  k8sTable,
  getK8InstanceByMetaProperties,
  getK8CardsProperties,
  readAllMetricsFilteredAtServiceScopeTemplate,
  getK8Attributes,
  k8sNamespaceTable,
  k8sServiceInstanceCount,
  getAllK8Instances,
  readMetricsValuesCompare,
  readAllMetricsFilteredAtServiceScopeTemplateCompare
};
